import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const Seo = ({
  description, lang, meta, title, img, isImgSanity, pathname,
}) => {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://etno-gatsby.netlify.app/';
  const { site, image } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
        image: file(relativePath: { eq: "meta-img.png" }) {
          childImageSharp {
            fixed(width: 1200, quality: 100) {
              src
            }
          }
        }
      }
    `,
  );

  const metaImage = `${isImgSanity ? '' : origin}${img || image.childImageSharp.fixed.src}`;
  const canonical = pathname ? `${site.siteMetadata.siteUrl}${pathname}` : null;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      link={canonical ? [{ rel: 'canonical', href: canonical }] : []}
      meta={[
        {
          name: 'description',
          content: description,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: description,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:image',
          content: metaImage,
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: description,
        },
        {
          name: 'twitter:image',
          content: metaImage,
        },
      ].concat(meta)}
    />
  );
};

Seo.defaultProps = {
  lang: 'en',
  meta: [],
  description: '',
  img: null,
  isImgSanity: false,
  pathname: null,
};

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  img: PropTypes.string,
  isImgSanity: PropTypes.bool,
  pathname: PropTypes.string,
};

export default Seo;
